import { defineStore } from 'pinia'
import { AttachmentApi, type FileAttachment } from '@/api-swagger'
import { ref } from 'vue'
import { withApiState } from '@/utils/withApiState'

export const useAttachmentStore = defineStore('attachment', () => {
  const api = new AttachmentApi()
  const loading = ref(false)
  const error = ref<string | null>(null)
  const attachments = ref<FileAttachment[]>([])

  async function getFiles(attachmentIds: number[]) {
    await withApiState(
      async () => {
        const response = await api.getFilesByAttachmentIds({ attachmentIds: attachmentIds })
        if (response.files) {
          attachments.value = response.files
        } else {
          throw new Error('Erreur lors de la récupération des fichiers.')
        }
      },
      { loading, error, errorText: 'Erreur lors de la récupération des fichiers.', logLabel: 'Erreur API :', rethrow: true },
    )
  }

  const uploadAttachments = async (files: File[], modelName: string, id: number) => {
    return withApiState(
      async () => {
        const response = await api.uploadAttachments({ files: files, modelName: modelName, id: id })
        if (response) {
          return response
        } else {
          throw new Error("Erreur lors de l'upload du fichier.")
        }
      },
      { loading, error, logLabel: 'Erreur API :', rethrow: true },
    )
  }

  const getAllAttachmentByRessourceId = async (ressourceId: number) => {
    await withApiState(
      async () => {
        const response = await api.getAttachmentsResourceId({ ressourceId: ressourceId })
        if (response) {
          if (response.length === 0) {
            attachments.value = []
          } else {
            getFiles(response)
          }
        } else {
          throw new Error('Erreur lors de la récupération des pièces jointes.')
        }
      },
      { loading, error, errorText: 'Erreur lors de la récupération des pièces jointes.', logLabel: 'Erreur API :', rethrow: true },
    )
  }

  const deleteAttachment = async (attachmentId: number) => {
    return withApiState(
      async () => {
        await api.deleteAttachment({ attachmentId: attachmentId })
        return true
      },
      { loading, error, errorText: 'Erreur lors de la suppression de la pièce jointe.', logLabel: 'Erreur API :', rethrow: true },
    )
  }
  return {
    attachments,
    uploadAttachments,
    getAllAttachmentByRessourceId,
    deleteAttachment,
    loading,
    error,
  }
})
